import { render } from "./MfittMyTicketPurchase.vue?vue&type=template&id=317acb10"
import script from "./MfittMyTicketPurchase.vue?vue&type=script&lang=js"
export * from "./MfittMyTicketPurchase.vue?vue&type=script&lang=js"
script.render = render

export default script